import { Link } from "react-router-dom";
import { ArrowRight, Flag, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import VinLookupCard from "@/components/sections/VinLookupCard";
import { BUSINESS } from "@/lib/constants";

const HERO_IMG = "https://images.unsplash.com/photo-1578245600656-e8fe67a2b5f7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800";

export default function HeroDark() {
  return (
      <section className="relative overflow-hidden bg-[#0A0A0B]" data-testid="hero">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover object-right opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0B] via-[#0A0A0B]/80 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent" />
          <div className="absolute inset-0 bg-grain opacity-40" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20 lg:pt-36 lg:pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
            <div className="lg:col-span-7 text-white">
              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 reveal reveal-1">
                <span className="eyebrow text-slate-400" data-testid="hero-veteran-badge"><Flag className="inline w-3.5 h-3.5 mr-2 -mt-0.5 text-slate-300" />Veteran-owned — Hayward, CA</span>
                <a href={BUSINESS.yelpUrl} target="_blank" rel="noopener noreferrer" data-testid="hero-yelp-badge" className="eyebrow text-slate-400 hover:text-white transition-colors">
                  <Star className="inline w-3.5 h-3.5 mr-2 -mt-0.5 fill-current text-[#FF1A1A]" />Rated {BUSINESS.yelpRating} on Yelp · {BUSINESS.yelpReviews} reviews
                </a>
              </div>
              <h1 className="headline-xl text-[clamp(2.8rem,6.2vw,6rem)] mt-7 text-[#F2F2F0] reveal reveal-2">
                We buy cars.<br />We pay more.<br /><span className="text-slate-500">Skip the hassle.</span>
              </h1>
              <p className="mt-8 text-base sm:text-lg text-slate-400 leading-relaxed max-w-lg reveal reveal-3">
                Get top dollar with us. Tell us about your car, we inspect it in person, and you get a real written offer. Same-day payment. No pressure.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row gap-3 reveal reveal-4">
                <Link to="/sell-your-car">
                  <Button data-testid="hero-cta-primary" className="h-14 px-8 bg-[#F2F2F0] hover:bg-white text-[#0A0A0B] text-sm font-bold uppercase tracking-[0.12em] rounded-none">
                    Request my offer <ArrowRight className="w-4 h-4 ml-3" />
                  </Button>
                </Link>
                <Link to="/how-it-works">
                  <Button data-testid="hero-cta-secondary" variant="outline" className="h-14 px-8 bg-transparent hover:bg-white/5 text-[#F2F2F0] border-white/25 hover:border-white/60 text-sm font-bold uppercase tracking-[0.12em] rounded-none">
                    How it works
                  </Button>
                </Link>
              </div>

              <dl className="mt-12 grid grid-cols-3 gap-6 max-w-lg border-t border-white/10 pt-6 reveal reveal-4" data-testid="hero-benefits">
                {[["3,000+", "cars bought"], ["25+ years", "in the business"], ["Same-day", "payment"]].map(([v, l]) => (
                  <div key={l}><dt className="font-display text-xl sm:text-2xl font-bold text-[#F2F2F0] tracking-tight">{v}</dt><dd className="eyebrow text-slate-500 mt-1">{l}</dd></div>
                ))}
              </dl>
              <p className="mt-8 eyebrow text-slate-500 reveal reveal-4">
                Prefer to talk? <a href={BUSINESS.phoneHref} className="text-slate-300 hover:text-white">Call</a> or <a href={BUSINESS.smsHref} data-testid="hero-sms-link" className="text-slate-300 hover:text-white">text</a> {BUSINESS.phone}
              </p>
            </div>

            <div className="lg:col-span-5 w-full reveal reveal-3">
              <VinLookupCard variant="dark" />
            </div>
          </div>
        </div>
      </section>
  );
}
